import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '_store';

export function ResetPassword() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
  //  const authError = useSelector(state => state.auth.error);
    const successMessage = useSelector(state => state.auth.successMessage);

    const [token, setToken] = useState('');
    const [email, setEmail] = useState('');

    const validationSchema = Yup.object().shape({
        password: Yup.string().required('Password is required')
            .min(6, 'Password must be at least 6 characters')
            .max(12, 'Password must not exceed 12 characters'),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Passwords must match')
            .required('Confirm Password is required')
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    const { register, handleSubmit, formState } = useForm(formOptions);
    // eslint-disable-next-line
    const { errors, isSubmitting } = formState;

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const token = queryParams.get('token');
        const email = queryParams.get('email');
        setToken(token);
        setEmail(email);
    }, []);

    function onSubmit({ password }) {
        return dispatch(authActions.resetPassword({ email, token, password }))
            .unwrap()
            .then((response) => {
                if (response && response.message) {
                    dispatch(authActions.setSuccessMessage(response.message));
                    navigate('../login'); 
                }
            })
            .catch((error) => {
                dispatch(authActions.setError(error?.message || ''));
            });
    }

    return (
        <div className="card m-3">
            <h4 className="card-header">Reset Password</h4>
            <div className="card-body">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-3">
                        <label className="form-label">New Password</label>
                        <input
                            name="password"
                            type="password"
                            {...register('password')}
                            className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                        />
                        <div className="invalid-feedback">{errors.password?.message}</div>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Confirm Password</label>
                        <input
                            name="confirmPassword"
                            type="password"
                            {...register('confirmPassword')}
                            className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                        />
                        <div className="invalid-feedback">{errors.confirmPassword?.message}</div>
                    </div>
                    {successMessage && <div className="alert alert-success">{successMessage}</div>} {/* Display success message */}
                    {/* {authError && !successMessage && <div className="alert alert-danger">{authError}</div>}  */}
                    
                    <div className="auth-button-stack">
  <button type="submit" className="btn btn-primary">Reset Password</button>
</div>

                </form>
            </div>
        </div>
    );
}
